import { mutator } from 'satcheljs';
import getStore from '../store/getStore';
import * as action from '../actions/advertisingOptionsActions';
import getOptions from '../selectors/getOptions';

mutator(action.toggleAllowAccess, msg => {
    const options = getOptions();
    getStore().allowAccess = !options.allowAccess;
    getStore().markOptionFormDirty = true;
});

mutator(action.toggleAllowPersonalization, msg => {
    const options = getOptions();
    getStore().allowPersonalization = !options.allowPersonalization;
    getStore().markOptionFormDirty = true;
});

mutator(action.toggleAllowAdSelection, msg => {
    const options = getOptions();
    getStore().allowAdSelection = !options.allowAdSelection;
    getStore().markOptionFormDirty = true;
});

mutator(action.toggleAllowContentSelection, msg => {
    const options = getOptions();
    getStore().allowContentSelection = !options.allowContentSelection;
    getStore().markOptionFormDirty = true;
});

mutator(action.toggleAllowMeasurement, msg => {
    const options = getOptions();
    getStore().allowMeasurement = !options.allowMeasurement;
    getStore().markOptionFormDirty = true;
});

mutator(action.switchView, msg => {
    getStore().showGdprPartnerListView = msg.switchToGdprPartnerListView;
});

mutator(action.setVendorList, msg => {
    getStore().vendorList = msg.vendorList;
});

mutator(action.setOptions, msg => {
    Object.keys(msg.options).forEach(key => {
        getStore()[key] = msg.options[key];
    });
});

mutator(action.setFormDirty, msg => {
    getStore().markOptionFormDirty = msg.setFormDirty;
});
